<template>
	<fieldset v-if="questionInfo" class="question-cnt">
		<legend class="heading-1 question-box" aria-live="polite">
			{{ questionInfo.question }}
		</legend>
		<ja-single-select
			v-if="
				questionInfo.cmsLifestyleQuestionFormat.questionFormat ==
					'Multiple options'
			"
			:answers="answers"
			:selected-answer="selectedAnswer"
			@answerSelected="selectAnswer"
		></ja-single-select>
		<ja-multi-select
			v-else-if="
				questionInfo.cmsLifestyleQuestionFormat.questionFormat == 'Multi Select'
			"
			:answers="answers"
			:selected-answer="selectedAnswer"
			@answerSelected="selectAnswer"
		></ja-multi-select>
		<ja-true-false-question
			v-else-if="
				questionInfo.cmsLifestyleQuestionFormat.questionFormat == 'True / False'
			"
			:selected-answer="selectedAnswer"
			@answerSelected="selectAnswer"
		></ja-true-false-question>
		<ja-free-text-question
			v-else-if="
				questionInfo.cmsLifestyleQuestionFormat.questionFormat == 'Text Only'
			"
			:selected-answer="selectedAnswer"
			@answerSelected="selectAnswer"
		></ja-free-text-question>
	</fieldset>
</template>
<script>
import SingleSelectQuestion from './QuestionFormats/SingleSelectQuestion';
import MultiSelectQuestion from './QuestionFormats/MultiSelectQuestion';
import TrueFalseQuestion from './QuestionFormats/TrueFalseQuestion';
import FreeTextQuestion from './QuestionFormats/FreeTextQuestion';

export default {
	components: {
		jaSingleSelect: SingleSelectQuestion,
		jaMultiSelect: MultiSelectQuestion,
		jaTrueFalseQuestion: TrueFalseQuestion,
		jaFreeTextQuestion: FreeTextQuestion
	},
	props: {
		questionId: {
			type: String,
			default: ''
		},
		questionInfo: {
			type: Object,
			default: () => {
				return {};
			}
		},
		selectedAnswer: {
			type: [String, Array, Boolean],
			default: null
		}
	},
	computed: {
		answers() {
			const answers = this.questionInfo.cmsLifestyleQuestionAnswerOptions;
			answers.sort((obj1, obj2) => {
				return obj1.optionOrder - obj2.optionOrder;
			});

			return answers;
		}
	},
	methods: {
		selectAnswer(data) {
			this.$emit('answerSelected', {
				question: this.questionId,
				answer: data.answer,
				text: data.text
			});
		}
	}
};
</script>
<style lang="scss" scoped>
.question-cnt {
	width: 100%;
	border: 0;

	.question-box {
		margin-top: 0;
		margin-bottom: 32px;
		outline: none;
	}
}
</style>
